import{makeStyles as m}from"@material-ui/core";var r=m({customGradientName:{minWidth:175,marginBottom:20}});export{r as useStyles};
